var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "popup-table",
      class: _vm.is_full_height ? "full-height" : "",
      staticStyle: { height: "fit-content" },
      style: _vm.is_full_width ? "width: 100%;" : "",
      attrs: { id: "popup_table" }
    },
    [
      _c(
        "div",
        {
          staticClass: "popup-table__wrapper",
          class: _vm.is_minimize ? "h-66px" : "h-100vh",
          staticStyle: { "min-height": "0" }
        },
        [
          _c(
            "div",
            { staticClass: "popup-table__container-title" },
            [
              _c("p", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.datetime_str) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.current_data.title))]),
              _vm._v(" "),
              _vm.is_full_height
                ? _c(
                    "v-btn",
                    {
                      staticClass: "maximize-btn",
                      staticStyle: { display: "inline-block" },
                      attrs: { color: "white", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.is_minimize = !_vm.is_minimize
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.is_minimize
                                ? "mdi-window-maximize"
                                : "mdi-window-minimize"
                            ) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "close-btn",
                  attrs: { color: "black", icon: "" },
                  on: { click: _vm.close_dialog }
                },
                [
                  _c("v-icon", { attrs: { color: "white" } }, [
                    _vm._v("\n                    mdi-close\n                ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "popup-table__container",
              class: _vm.is_minimize ? "h-0vh" : "h-100vh"
            },
            [
              _c(
                "div",
                { staticClass: "popup-table__content-wrapper" },
                [
                  _vm.is_raw_html
                    ? _c("div", {
                        staticClass:
                          "popup-table__content popup-table__content--image",
                        domProps: {
                          innerHTML: _vm._s(_vm.current_data.content)
                        }
                      })
                    : _vm.popup_type === "description_info" &&
                      _vm.COLUMNAR_TYPE.includes(_vm.product_sub_type)
                      ? _c(
                          "div",
                          { staticClass: "alert-table__wrapper" },
                          _vm._l(_vm.current_data.content, function(ref) {
                            var name = ref.name
                            var value = ref.value
                            return _c("div", { key: name }, [
                              _c(
                                "div",
                                { staticClass: "alert-table__sub-header" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(name) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "alert-table__content",
                                domProps: { innerHTML: _vm._s(value) }
                              })
                            ])
                          }),
                          0
                        )
                      : _vm.popup_type === "description_info" &&
                        _vm.product_sub_type === "lightning_alert"
                        ? _c("div", { staticClass: "alert-table__wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "alert-table__content" },
                              _vm._l(_vm.current_data.content, function(
                                item,
                                key
                              ) {
                                return _c("p", { key: key }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item) +
                                      "\n                        "
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        : _c(
                            "div",
                            {
                              staticClass: "popup-table__content h-39vh",
                              class: {
                                "two-column": _vm.is_two_column
                              }
                            },
                            _vm._l(_vm.current_data.content, function(datum) {
                              return _c(
                                "div",
                                {
                                  key: datum.name,
                                  staticClass: "popup-table__content-item"
                                },
                                [
                                  datum.name !== "時間" &&
                                  _vm.popup_type === "gis_popup_data"
                                    ? [
                                        _c("h6", [_vm._v(_vm._s(datum.name))]),
                                        _vm._v(" "),
                                        _c("p", [_vm._v(_vm._s(datum.value))])
                                      ]
                                    : datum.name !== "警示條件" &&
                                      _vm.popup_type === "description_info"
                                      ? [
                                          _c("h6", [
                                            _vm._v(_vm._s(datum.name))
                                          ]),
                                          _vm._v(" "),
                                          _c("p", {
                                            class: {
                                              "small-font-size": _vm.small_font_size_column.includes(
                                                datum.name
                                              )
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(datum.value)
                                            }
                                          })
                                        ]
                                      : _vm._e()
                                ],
                                2
                              )
                            }),
                            0
                          ),
                  _vm._v(" "),
                  _vm.popup_type === "description_info" &&
                  _vm.product_sub_type === "monitor"
                    ? [
                        _c(
                          "div",
                          { staticClass: "popup-table__content one-column" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.rain_notice_content.name === "警示條件"
                                    ? _vm.rain_notice_content.name
                                    : "無警示條件"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.rain_notice_content.name === "警示條件"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    _vm.rain_notice_content.value,
                                    function(notice, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "popup-table__content-item"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(_vm._s(notice.name) + "：")
                                          ]),
                                          _vm._v(" "),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(notice.value)
                                            }
                                          })
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm.GIS_CHART_TYPE.includes(_vm.gis_popup_type)
            ? [
                _c(
                  "v-btn",
                  {
                    staticClass: "diagram-btn",
                    on: {
                      click: function($event) {
                        return _vm.$emit("show-gis-diagram")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("__gis.diagram")) +
                        "\n            "
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }